import { ProfilePage } from "components/ProfilePage"
import { AlbumCard } from "components/AlbumCard"
import * as React from "react"
import { Text } from "components/Text"
import { useTranslator } from "components/Translator"
import { PlusCircle } from "components/Icon"
import { Button } from "components/Button"
import { useConnectedUser } from "components/ConnectedUserProvider"
import { LikesProvider } from "components/LikesProvider"
import * as LikeType from "enums/LikeType"
import { Pagination } from "components/Pagination"

export function AccountAlbumIndexPage({
  user,
  infos,
  albums: albumsProps,
  pagination,
  tabs = window.accountNav,
}) {
  const translator = useTranslator()
  const connectedUser = useConnectedUser()
  const [albums, setAlbums] = React.useState(albumsProps)

  const handleDelete = (deletedAlbum) => {
    setAlbums((prevAlbums) =>
      prevAlbums.filter((album) => album.id !== deletedAlbum.id),
    )
  }

  const albumIds = React.useMemo(
    () => albumsProps.map((album) => album.id),
    [albumsProps],
  )

  const isOwnProfile = connectedUser?.id === user.id

  const extraActions = [
    isOwnProfile ? (
      <Button
        key="add-album"
        href={{ route: "app_user_album_add" }}
        iconLeft={<PlusCircle className="w-4" />}
        fullWidth
      >
        {translator.trans("account.album.index.add", null, "pages")}
      </Button>
    ) : null,
  ].filter(Boolean)

  return (
    <ProfilePage
      user={user}
      tabs={tabs}
      infos={infos}
      extraActions={extraActions}
    >
      <div className="space-y-6 lg:space-y-12">
        {albums.length > 0 ? (
          <LikesProvider type={LikeType.ALBUM} ids={albumIds}>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {albums.map((album) => {
                return (
                  <AlbumCard
                    key={album.id}
                    album={album}
                    ownerId={user.id}
                    onDelete={handleDelete}
                  />
                )
              })}
            </div>
          </LikesProvider>
        ) : (
          <Text tag="p">
            {translator.trans(
              "account.album.index.emptyMessage",
              null,
              "pages",
            )}
          </Text>
        )}
        <Pagination
          currentPageNumber={pagination.currentPageNumber}
          itemNumberPerPage={pagination.itemNumberPerPage}
          totalItemCount={pagination.totalItemCount}
          pageRange={2}
        />
      </div>
    </ProfilePage>
  )
}
